module.exports = __webpack_public_path__ + "20358324607ef7fc88f8cd0d7a083a6e.svg";